import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { communityExtras } from "../data/content";
import { body, eyebrow, h2, section, shell } from "../utils/styles";
export function Community() {
  return <section id="comunidad" className={`${shell} ${section}`} data-id="element-26" data-mp="hlluyi8xelxy">
      <div className="-mx-[3px] grid gap-8 rounded-[18px] border border-[#414c36] px-[22px] py-[27px] sm:mx-0 sm:grid-cols-2 sm:gap-[35px] sm:p-8 lg:gap-[65px] lg:p-12" style={{
      background: "radial-gradient(ellipse at top left, #2d3923, #1a2017 65%)"
    }} data-id="element-27" data-mp="mjnnruw5lzmm">
        <div data-id="element-28" data-mp="3q2gov87qwvzw">
          <p className={eyebrow} data-id="element-29" data-mp="3uzguji0onwqh">Formación + comunidad + acompañamiento</p>
          <h2 className={h2} data-id="element-30" data-mp="3uy5r5jb5gqzw">No tenés que resolver todo por tu cuenta</h2>
          <p className={`${body} max-w-[355px]`} data-id="element-31" data-mp="3txkski8m7jm">
            Traé tus dudas sobre el ebook, la oferta o la venta. En estos encuentros trabajamos sobre los pasos que
            necesitás dar para avanzar.
          </p>
          <a href="#unirme" className="mt-2.5 inline-flex items-center gap-7 rounded-lg border border-[#75895c] px-[21px] py-4 text-[13px] font-bold text-lime transition-colors duration-200 hover:bg-lime/10" data-id="element-32" data-mp="1f6hwjujlzak9">
            Quiero sumarme
            <ArrowRightIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-33" data-mp="914qkka92cbx" />
          </a>
        </div>

        <div data-id="element-34" data-mp="42b80dg3vv4w">
          <div className="rounded-xl bg-lime p-6 text-[#192210] sm:p-7" data-id="element-35" data-mp="42l48irquyj1">
            <small className="text-[10px] font-semibold uppercase tracking-[1.5px] text-[#526538]" data-id="element-36" data-mp="3vafn49y26ie9">En vivo con Marcos</small>
            <h3 className="mb-[21px] mt-[15px] font-display text-[29px] font-medium leading-[1.2] tracking-[-1.3px] sm:text-[31px]" data-id="element-37" data-mp="3qhcsdyhjp2wh">
              Dos asesorías semanales
            </h3>
            <div className="flex gap-2" data-id="element-38" data-mp="3hjan36qs3o3e">
              {["Miércoles", "Viernes"].map(d => <span key={d} className="rounded-[5px] border border-[#9ab765] px-3 py-[7px] text-[11px] font-medium" data-id="element-39" data-mp="3chl9pkg32yc5">
                  {d}
                </span>)}
            </div>
            <p className="mt-[17px] text-xs leading-[1.75] text-[#4a5d35]" data-id="element-40" data-mp="2xveft5udwbqc">
              Resolvemos lo que te frena y definimos tus próximos pasos.
            </p>
          </div>

          {communityExtras.map((c, i) => <div key={c.title} className="mt-3 flex gap-[18px] rounded-[10px] border border-[#3c4633] p-5" data-id="element-41" data-mp="2o04d0fw5w0bi" data-mpi={i}>
              <b className="font-display text-2xl font-normal leading-none text-lime" data-id="element-42" data-mp="2syxqi8bg7rbo">{i + 1}</b>
              <div data-id="element-43" data-mp="3gp1i1hbd40mb">
                <h3 className="mb-[5px] font-display text-sm font-semibold" data-id="element-44" data-mp="3lliinazr07ga">{c.title}</h3>
                <p className="text-[11px] leading-[1.75] text-muted" data-id="element-45" data-mp="36wvssfchvxat">{c.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}